export const ANALYTICS_SCHEMA_VERSION = 1;

export const ANALYTICS_EVENT_NAMES = [
  "app_open",
  "app_became_visible",
  "app_became_hidden",
  "pwa_install_prompt_seen",
  "pwa_installed",
  "storage_persist_requested",
  "storage_persist_result",
  "screen_view",
  "draft_created",
  "room_created",
  "room_deleted",
  "condition_created",
  "condition_deleted",
  "condition_opened",
  "photo_picker_opened",
  "photo_selected",
  "photo_compress_started",
  "photo_compress_success",
  "photo_compress_failed",
  "photo_save_success",
  "photo_save_failed",
  "mic_permission_denied",
  "audio_record_started",
  "audio_record_stopped",
  "audio_save_success",
  "audio_save_failed",
  "transcription_queued",
  "transcription_retry_scheduled",
  "transcription_success",
  "transcription_failed",
  "note_typed",
  "ai_suggestion_available",
  "ai_suggestion_applied",
  "note_approved",
  "note_marked_ready",
  "export_screen_opened",
  "pdf_generate_started",
  "pdf_generate_success",
  "pdf_generate_failed",
  "pdf_download_clicked",
  "runtime_error",
  "unhandled_rejection",
  "db_error",
  "quota_exceeded",
  "service_worker_error",
  "service_worker_updated",
  "offline_queue_flush_success",
  "offline_queue_flush_failed"
] as const;

export type AnalyticsEventName = (typeof ANALYTICS_EVENT_NAMES)[number];

export type AnalyticsScreen =
  | "start"
  | "rooms"
  | "room_detail"
  | "condition_note_detail"
  | "review"
  | "export"
  | "admin_login"
  | "admin_dashboard";

export type ConsentState = "not_shown" | "notice_shown" | "accepted" | "opted_out" | "internal_qa";
export type ViewportClass = "mobile" | "tablet" | "desktop" | "unknown";
export type DisplayMode = "browser" | "standalone" | "installed" | "unknown";

export interface AnalyticsContext {
  routePattern?: string;
  screen?: AnalyticsScreen;
  viewportClass: ViewportClass;
  browserFamily: string;
  platformFamily: string;
  online: boolean;
  displayMode: DisplayMode;
  host?: string;
}

export interface AnalyticsEvent {
  eventId: string;
  installId: string;
  sessionId: string;
  sequence: number;
  schemaVersion: typeof ANALYTICS_SCHEMA_VERSION;
  appVersion: string;
  buildHash?: string;
  eventName: AnalyticsEventName;
  clientCreatedAt: string;
  analyticsEnabled: boolean;
  noticeVersion: string;
  consentState: ConsentState;
  context: AnalyticsContext;
  payload: AnalyticsPayload;
}

export type AnalyticsPayload = Record<string, string | number | boolean | null | undefined>;

export type AnalyticsPriority = "normal" | "critical";
